import React from 'react'
import logo from '../../images/PLLStats.png'
import { logEvent } from '../../Utils/analytics/firAnalytics'
import { Img } from '../Images/Img'
import { ANALYTICS_TAGS } from '../../Constants/analytics'
import {
  Nav,
  NavHeader,
  LogoLink,
  LogoIcon,
  NavLinkContainer,
  NavLinks,
  StyledNavLink,
} from './styles'

const Navbar: React.FC = () => {
  const logStatsNavClick = (tab: string, link: string): void => {
    logEvent(ANALYTICS_TAGS.stats_nav_click, {
      tab,
      link,
    })
  }

  return (
    <Nav>
      <NavHeader>
        <LogoLink aria-label="PLL Stats Logo" to="/">
          <LogoIcon>
            <Img src={logo} alt="Premier Lacrosse League Logo" />
          </LogoIcon>
        </LogoLink>
        <NavLinkContainer>
          <NavLinks>
            <StyledNavLink
              to="/"
              end
              onClick={() => logStatsNavClick('Home', '/')}
            >
              Home
            </StyledNavLink>
            <StyledNavLink
              to="/players"
              onClick={() => logStatsNavClick('Players', '/players')}
            >
              Players
            </StyledNavLink>
            <StyledNavLink
              to="/teams"
              onClick={() => logStatsNavClick('Teams', '/teams')}
            >
              Teams
            </StyledNavLink>
            <StyledNavLink
              to="/games"
              onClick={() => logStatsNavClick('Games', '/games')}
            >
              Games
            </StyledNavLink>
            <StyledNavLink
              to="/advanced-stats"
              onClick={() => logStatsNavClick('Advanced', '/advanced-stats')}
            >
              Advanced Stats
            </StyledNavLink>
          </NavLinks>
        </NavLinkContainer>
      </NavHeader>
    </Nav>
  )
}

export default Navbar
